
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/activewear",
      function () {
        return require("private-next-pages/apparel/activewear/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/activewear"])
      });
    }
  